import React, { PropsWithChildren, useMemo } from 'react';

import styles from './Stepper.module.scss';
import { CLASSES } from '../../helper/functions';
import useStepperStore, { StepperItem } from '../../store/StepperStore';
import Icon from '../icon/Icon';

const Stepper: React.FC<PropsWithChildren> = ({ children }) => {
  const { data: stepperItem } = useStepperStore();

  const currentItem: StepperItem | undefined = useMemo(() => {
    return stepperItem.find((stepper) => stepper.status == 1);
  }, [stepperItem]);

  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <div className={styles.stepperContainer}>
          <div className={styles.mainLogoContainer}>
            <Icon className={styles.mainLogo} src="/images/MainLogo.png" flat />
          </div>

          {stepperItem &&
            stepperItem.map((form) => (
              <div key={form.id} className={styles.stepperContainerItem}>
                <div
                  className={CLASSES(
                    styles.selectedForm,
                    form.status > 0 && styles.selected__
                  )}
                >
                  {form.status == 2 ? (
                    <Icon src="/icons/untick.svg" />
                  ) : form.status == 3 ? (
                    <Icon src="/icons/tick.svg" />
                  ) : (
                    form.id
                  )}
                </div>

                <div className={styles.stepperContainerItemLabel}>
                  {form.label}
                </div>
              </div>
            ))}
        </div>

        <div className={styles.formContainer}>
          <div className={styles.formLabel}>{currentItem?.label}</div>
          <div className={styles.formContentContainer}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
